export default {"src":"/_next/static/media/sweateconomy_logo.86ccf531.svg","height":20,"width":210,"blurWidth":0,"blurHeight":0};